export default __webpack_public_path__ + "static/banner-ffdbb59edd2fd7ad72eb5b421b39f44c.png";